"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const client_1 = require("../../../model/client");
const auth_1 = require("../../../utils/auth");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const new_contract_form_1 = require("../contract/new_contract_form");
const client_form_1 = require("./client_form");
exports.ClientTable = (0, table_1.createTable)({
    id: "clientTable",
    filters: {
        "empty_soon": "Forfait bientot épuisés",
        "expire_soon": "Forfait bientot expirés",
        "new_client": "Nouveaux clients",
        "has_waiting_payment": "Moyens de paiements en attente de reception",
        "active": "Actif uniquement",
        "unactive": "Désactivé uniquement",
    },
    provider: client_1.ClientProvider,
    title: "Clients",
    topMenuRight: () => {
        let table = exports.ClientTable;
        return (0, helpers_1.buttonGroup)((0, mithril_1.default)("a", { class: "button is-success", onclick: () => { client_form_1.ClientForm.show(); } }, (0, helpers_1.iconSpan)("fa-user-plus", "is-small"), (0, mithril_1.default)("span", "Nouveau Client")), (0, mithril_1.default)("a", { class: "button is-primary", target: "_blank", href: app_1.App.serviceURL(`/clients/export?__at__=${auth_1.Auth.uriEncodedToken()}&search=${table.state.search}`) }, (0, helpers_1.iconSpan)("fa-download", "is-small"), (0, mithril_1.default)("span", "Exporter")));
    },
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "active",
            sortable: false,
            label: "Actif",
            renderer: table_renderers_1.TableRenderers.bool
        },
        {
            name: "first_name",
            sortable: true,
            label: "Prénom"
        },
        {
            name: "last_name",
            sortable: true,
            label: "Nom"
        },
        {
            name: "job_title",
            sortable: true,
            label: "Profession",
        },
        {
            name: "created_at",
            sortable: true,
            label: "Créé le",
            renderer: table_renderers_1.TableRenderers.date
        },
        {
            name: "remaining_minutes",
            sortable: false,
            label: "Heures reservables restantes",
            renderer: table_renderers_1.TableRenderers.time
        },
        {
            name: "has_waiting_payment",
            sortable: false,
            label: "Moyen de paiements reçu",
            renderer: (mdl, _value) => {
                return table_renderers_1.TableRenderers.bool(mdl, !mdl.has_waiting_payment);
            }
        },
        {
            name: "last_expiration_date",
            sortable: false,
            label: "Expiration du dernier forfait",
            renderer: table_renderers_1.TableRenderers.date
        }
    ],
    actions: (obj) => {
        return (0, mithril_1.default)("div", { class: "" }, (0, helpers_1.buttonGroup)((0, mithril_1.default)("a", { class: "button is-success",
            title: "Nouveau forfait",
            onclick: () => {
                new_contract_form_1.NewContractForm.show({
                    client_id: parseInt(`${obj.id}`)
                });
            } }, (0, helpers_1.iconSpan)("fa-file-signature"), (0, helpers_1.iconSpan)("fa-plus"), (0, mithril_1.default)("span", "Forfait")), (0, mithril_1.default)("a.button.is-primary", { title: "Afficher", onclick: () => { right_panel_1.RightPanel.open("clients", obj.id, "show"); } }, (0, helpers_1.iconSpan)("fa-eye"), (0, mithril_1.default)("span", "Afficher"))));
    }
});
